"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPool = createPool;
exports.configurePool = configurePool;
exports.fundPoolLoan = fundPoolLoan;
exports.deployPoolLoan = deployPoolLoan;
exports.setPoolLoansDeployer = setPoolLoansDeployer;
exports.setPoolLoansOperator = setPoolLoansOperator;
exports.updatePoolProcessingHour = updatePoolProcessingHour;
exports.updatePoolIssuanceLimits = updatePoolIssuanceLimits;
exports.pausePoolDepositsAndWithdrawals = pausePoolDepositsAndWithdrawals;
exports.changePoolLoanAPR = changePoolLoanAPR;
exports.setPoolLoanFees = setPoolLoanFees;
function createPool(signer, params) {
    return __awaiter(this, void 0, void 0, function* () {
    });
}
function configurePool(signer, params) {
    return __awaiter(this, void 0, void 0, function* () {
    });
}
function fundPoolLoan(signer, params) {
    return __awaiter(this, void 0, void 0, function* () {
    });
}
function deployPoolLoan(signer, params) {
    return __awaiter(this, void 0, void 0, function* () {
    });
}
function setPoolLoansDeployer(signer, params) {
    return __awaiter(this, void 0, void 0, function* () {
    });
}
function setPoolLoansOperator(signer, params) {
    return __awaiter(this, void 0, void 0, function* () {
    });
}
function updatePoolProcessingHour(signer, params) {
    return __awaiter(this, void 0, void 0, function* () {
    });
}
function updatePoolIssuanceLimits(signer, params) {
    return __awaiter(this, void 0, void 0, function* () {
    });
}
function pausePoolDepositsAndWithdrawals(signer, params) {
    return __awaiter(this, void 0, void 0, function* () {
    });
}
function changePoolLoanAPR(signer, params) {
    return __awaiter(this, void 0, void 0, function* () {
    });
}
function setPoolLoanFees(signer, params) {
    return __awaiter(this, void 0, void 0, function* () {
    });
}
//# sourceMappingURL=admin-actions.js.map